export default __webpack_public_path__ + "static/media/screenshot21.65cc3562.jpg";